import React from 'react';
import Trash from '../../../icons/trash';

interface HALPopoverProps {
    halId: string;
    halTitle: string; // Le titre stocké dans l'attribut data-hal-title
    onRemove: () => void;
    position: { top: number; left: number };
}

const HALPopover: React.FC<HALPopoverProps> = ({
    halId,
    halTitle,
    onRemove,
    position
}) => {
    // Pas besoin de fetch si on a déjà le titre dans l'attribut, 
    // mais on pourrait fetcher pour avoir plus de détails si besoin.
    // Pour l'instant, on utilise le titre fourni.

    return (
        <div
            className="absolute z-50 bg-mcdm-primary-100 dark:bg-mcdm-primary-100 border border-gray-300 rounded shadow-md p-2 min-w-[200px]"
            style={{ top: `${position.top}px`, left: `${position.left}px` }}
        >
            <p className="mb-2 text-sm text-mcdm-third-500">
                <strong>Référence HAL :</strong>{' '}
                <span className="block italic mt-1">{halTitle || halId}</span>
            </p>
            <button
                onClick={onRemove}
                className="flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white text-sm py-1 px-2 rounded w-full justify-center"
            >
                <Trash width="14px" height="14px" fill="white" />
                Supprimer la référence
            </button>
        </div>
    );
};

export default HALPopover;
